"use client"

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/shared/components/ui/accordion"

const faqs = [
  {
    question: "¿Qué es Rapyfact y cómo funciona?",
    answer:
      "Rapyfact es una plataforma integral de facturación electrónica diseñada específicamente para el sector salud en Colombia. Automatiza la generación, validación y envío de facturas electrónicas cumpliendo con todos los requisitos de la DIAN. Simplemente integras tu sistema, generas las facturas y nosotros nos encargamos del resto.",
  },
  {
    question: "¿Cuánto tiempo toma implementar Rapyfact?",
    answer:
      "La implementación típica toma entre 1 y 2 horas. Nuestro equipo técnico te acompaña en todo el proceso de integración y capacitación. Muchos de nuestros clientes están operando completamente en menos de 2 horas.",
  },
  {
    question: "¿Rapyfact cumple con la normativa DIAN?",
    answer:
      "Sí, absolutamente. Rapyfact está 100% actualizado con la normativa vigente de la DIAN para facturación electrónica. Nuestro sistema se actualiza automáticamente con cualquier cambio en la regulación, garantizando que siempre estés en cumplimiento.",
  },
  {
    question: "¿Qué tipo de soporte técnico ofrecen?",
    answer:
      "Ofrecemos soporte técnico 8/5 a través de múltiples canales: chat en vivo, correo electrónico, teléfono y WhatsApp. Nuestro equipo de expertos está siempre disponible para resolver cualquier duda o problema que puedas tener.",
  },
  {
    question: "¿Rapyfact cumple con la Resolución 2275?",
    answer:
      "Sí. Rapyfact cumple plenamente con los lineamientos establecidos en la Resolución 2275. Nuestra plataforma ofrece integración con RIPS en formato JSON, así como la validación y obtención del CUV directamente ante el Ministerio de Salud, garantizando el cumplimiento normativo y la trazabilidad de la información.",
  },
  {
    question: "¿Qué pasa con mis datos? ¿Son seguros?",
    answer:
      "La seguridad de tus datos es nuestra máxima prioridad. Utilizamos encriptación de nivel bancario, almacenamiento en la nube con respaldos automáticos diarios, y cumplimos con todas las normativas de protección de datos. Tus facturas y datos están completamente seguros con nosotros.",
  },
]

export function FAQSection() {
  return (
    <section className="py-24 lg:py-32 bg-background relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `linear-gradient(to right, hsl(var(--foreground)) 1px, transparent 1px),
                           linear-gradient(to bottom, hsl(var(--foreground)) 1px, transparent 1px)`,
          backgroundSize: "64px 64px",
        }}
      />

      <div className="container relative mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-16 lg:mb-20">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-balance">
              Preguntas <span className="text-primary">frecuentes</span>
            </h2>
            <p className="text-lg sm:text-xl text-muted-foreground text-pretty">
              Encuentra respuestas a las preguntas más comunes sobre Rapyfact
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-border rounded-xl px-6 bg-card hover:border-primary/30 transition-colors duration-300"
              >
                <AccordionTrigger className="text-left text-lg font-semibold hover:text-primary py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 text-center">
            <p className="text-xl-foreground mb-4">¿No encuentras lo que buscas?</p>
            <a href="/contacto" className="text-primary font-semibold hover:underline inline-flex items-center gap-2">
              Contáctanos directamente →
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
